"use client";

import * as React from "react";

import { ExchangeSelect } from "@/components/ui/exchangeSelect";
import { usePathname } from "@/lib/i18n";
import { addSelectedExchangeData } from "@/services/db";
import { useAppDispatch, useAppSelector } from "@/services/hooks/redux.hooks";
import { setFocusedPortfolio } from "@/services/redux/dashboard.slice";
import { setSelectedExchange } from "@/services/redux/exchange-switcher.slice";

export function ExchangeSwitcher({ inAsset }: { inAsset?: boolean }) {
  const { connectedKeys, isSideBarCollapsed, selectedExchange } =
    useAppSelector((state) => state.exchangeSwitcher);
  const { portfolios } = useAppSelector((state) => state.dashboard);
  const pathname = usePathname();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (
      (pathname.includes("/trade") ||
        pathname.includes("/smart-allocation") ||
        pathname === "/asset") &&
      (selectedExchange?.provider_id == null ||
        selectedExchange.key_status_name === "READ_ONLY")
    ) {
      const filtered = connectedKeys.filter(
        (e) => e.provider_id != null && e.key_status_name === "VALID",
      )[0];
      addSelectedExchangeData(filtered);
      dispatch(setSelectedExchange(filtered));
      dispatch(
        setFocusedPortfolio(
          portfolios.find((e) => e.id === filtered?.exchange_key_id) as any,
        ),
      );
    } else {
      if (
        pathname.includes("/dashboard") &&
        !connectedKeys.filter(
          (e) => e.provider_id != null && e.key_status_name === "VALID",
        ).length &&
        connectedKeys.length
      ) {
        addSelectedExchangeData(
          connectedKeys.filter((e) => e.provider_id == null)[0],
        );
        dispatch(
          setSelectedExchange(
            connectedKeys.filter((e) => e.provider_id == null)[0],
          ),
        );
      }
    }
  }, [
    connectedKeys,
    dispatch,
    pathname,
    portfolios,
    selectedExchange?.account_type,
    selectedExchange?.key_status_name,
    selectedExchange?.exchange_key_id,
    selectedExchange?.provider_id,
  ]);

  return (
    <ExchangeSelect
      exchanges={connectedKeys.filter((e) =>
        pathname.includes("/trade") ||
        pathname.includes("/smart-allocation") ||
        inAsset
          ? e.provider_id != null
          : e,
      )}
      inAsset={inAsset}
      isCollapsed={isSideBarCollapsed && !inAsset}
    />
  );
}
